import Segment from './segment';
import SimpleWizard from './simple-wizard';
import AsyncForm from './async-form';

/* eslint-disable no-underscore-dangle */
export default class Lightbox {
	constructor({ element }) {
		this._element = element;
		this._html = document.documentElement;
		this._injector = element.querySelector('[data-injector]');

		window.addEventListener('lightbox-show-by-template-id', (e) => {
			this.showByTemplateId({
				templateId: e.detail && e.detail.templateId,
				data: e.detail && e.detail.data,
			});
		});

		window.addEventListener('lightbox-close', () => {
			this.closeLightbox();
		});
	}

	closeLightbox() {
		this._injector.innerHTML = '';
		this._element.classList.remove('is-open');
		this._html.classList.remove('lightbox-is-open');
	}

	showByTemplateId({ templateId, data }) {
		const template = document.querySelector(`[data-template-id="${templateId}"]`);
		if (!template) {
			throw Error('no template found!');
		}

		const clone = document.importNode(template.content, true);

		if (clone.querySelectorAll('[data-segment]').length > 0) {
			// eslint-disable-next-line no-new
			new Segment({ elements: clone.querySelectorAll('[data-segment]') });
		}

		if (data != null) {
			const projectId = clone.getElementById('MoreInfo.TemplateKey');
			if (projectId != null) projectId.value = data;
		}

		this._element.classList.add('is-open');

		this._html.classList.add('lightbox-is-open');

		this._injector.appendChild(clone);

		if (this._injector.querySelectorAll('.simple-wizard__fieldset').length > 0) {
			SimpleWizard.init();
		}

		if (this._element.querySelectorAll('[data-async-form]').length > 0) {
			// eslint-disable-next-line no-new
			new AsyncForm({ elements: this._element.querySelectorAll('[data-async-form]') });
		}
	}
}
